exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@keyframes spinAround{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}.footer{background-color:#fafafa;padding:3rem 1.5rem 6rem}", ""]);

// exports
